import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filterData: {
    search: null
  }
};

const fliterSlice = createSlice({
  name: 'filterVendor',
  initialState,
  reducers: {
    updateVendorFliter: (state, action) => {
      state.filterData = action.payload;
    },
    resetVendorFilter: () => initialState
  }
});

export default fliterSlice.reducer;
export const { updateVendorFliter, resetVendorFilter } = fliterSlice.actions;
